var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addGroup-container" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title: "添加群聊",
            visible: _vm.groupVisible,
            "close-on-click-modal": false,
            width: "80%",
            "close-on-press-escape": "",
            center: "",
            top: "2vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.groupVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c(
            "div",
            { staticClass: "cus-chat-supervise-search" },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "群名称：" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", clearable: "" },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.formInline.chatName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "chatName", $$v)
                          },
                          expression: "formInline.chatName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "群主：" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", clearable: "" },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.formInline.ownerName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "ownerName", $$v)
                          },
                          expression: "formInline.ownerName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "群标签：" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.tagList,
                          props: _vm.tagProps,
                          size: "mini",
                          "show-all-levels": false
                        },
                        on: { change: _vm.selectTagItem },
                        model: {
                          value: _vm.searchTagItem,
                          callback: function($$v) {
                            _vm.searchTagItem = $$v
                          },
                          expression: "searchTagItem"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "建群时间：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          size: "small",
                          "picker-options": _vm.pickerOptions
                        },
                        on: { change: _vm.selectBindStatus },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                size: "small",
                data: _vm.tableData,
                fit: "",
                "highlight-current-row": "",
                align: "center",
                "header-cell-style": { background: "#eef1f6" },
                height: "500",
                "row-key": _vm.getRowKeys
              },
              on: { select: _vm.handleSelectionChange }
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: {
                    type: "selection",
                    "reserve-selection": "",
                    width: "55",
                    selectable: _vm.selectable
                  }
                },
                [_c("template", { slot: "header" })],
                2
              ),
              _c("el-table-column", {
                attrs: {
                  prop: "chatName",
                  label: "群名称",
                  "show-overflow-tooltip": "",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "ownerName", label: "群主", align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "groupChatTagDetailDtoList",
                  label: "群标签",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(
                        scope.row.groupChatTagDetailDtoList,
                        function(item) {
                          return _c(
                            "el-tag",
                            {
                              key: item.tagId,
                              staticStyle: { margin: "3px" },
                              attrs: { size: "small" }
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-start",
                                    width: "150",
                                    trigger: "hover"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(item.tagName))]
                                  ),
                                  _vm._l(
                                    scope.row.groupChatTagDetailDtoList,
                                    function(item) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: item.tagId,
                                          staticStyle: { margin: "3px" },
                                          attrs: { size: "small" }
                                        },
                                        [_vm._v(_vm._s(item.tagName))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }
                      )
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "memNum", label: "群人数", align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "建群时间",
                  align: "center"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "staff-pagination" },
            [
              _c("el-pagination", {
                staticClass: "pagination-wrap",
                attrs: {
                  "current-page": _vm.formInline.pageNum,
                  "page-size": _vm.formInline.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.formInline.total,
                  "page-sizes": [20, 50, 100, 200, 500]
                },
                on: {
                  "current-change": _vm.currentChange,
                  "size-change": _vm.sizeChange,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.formInline, "pageNum", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.formInline, "pageNum", $event)
                  },
                  "update:pageSize": function($event) {
                    return _vm.$set(_vm.formInline, "pageSize", $event)
                  },
                  "update:page-size": function($event) {
                    return _vm.$set(_vm.formInline, "pageSize", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.handleCancel } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.handleSumbit }
                },
                [_vm._v("选择")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }